
export enum Value {
	BorderRadius = '0.5rem',
	BorderRadius_Field = '0.5rem',
	BorderRadius_Button = '0.5rem'
}
